import type { CSSProperties, ImgHTMLAttributes } from 'react';

import { rasterRegistry, type RasterImageName } from '~assets/raster/generated';

export type { RasterImageName };

export interface Props extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
	/** Namespaced token, e.g. "device/model/skbiel-03". */
	name: RasterImageName;
	/** Shorthand that sets both width and height. `width`/`height` still override. */
	size?: number | string;
	/** Native CSS `object-fit` value. Defaults to `cover`. */
	objectFit?: CSSProperties['objectFit'];
}

/**
 * Renders a raster (png/jpg/...) asset by name: `<RasterImage name="device/model/skbiel-03" />`.
 *
 * Resolves the token to its bundled URL and renders an `<img>`. Decorative by
 * default (`alt=""`); pass a meaningful `alt` when the image conveys content.
 */
const RasterImage = ({
	name,
	size,
	objectFit = 'cover',
	width,
	height,
	style,
	alt = '',
	...props
}: Props) => (
	<img
		src={rasterRegistry[name]}
		width={width ?? size}
		height={height ?? size}
		alt={alt}
		style={{ objectFit, ...style }}
		{...props}
	/>
);

export default RasterImage;
